import { useEffect } from 'react';
import { dispatchRipple } from '@/lib/ripple-bus';

/**
 * Captura cliques em qualquer ponto da viewport e dispara uma onda
 * a partir do ponto do clique. Monte uma única vez no app.
 */
export function RippleOnClick() {
  useEffect(() => {
    const onPointerDown = (event: PointerEvent) => {
      if (
        event.pointerType === 'touch' ||
        event.pointerType === 'mouse' ||
        event.pointerType === 'pen'
      ) {
        dispatchRipple(event.clientX, event.clientY);
      }
    };
    window.addEventListener('pointerdown', onPointerDown);
    return () => window.removeEventListener('pointerdown', onPointerDown);
  }, []);

  return null;
}
